export default __webpack_public_path__ + "static/media/close-filter.2ce78a51.svg";